import { properties } from "@repoflow/common/schema-fields";

const { createdAt,
  updatedAt } = properties

export {
  createdAt,
  updatedAt
}

export const orgId = {
  type: "string"
};
export const pointId = {
  label: "PointId",
  type: "string"
};

export const description = {
  label: "Description",
  type: "string"
};

export const status = {
  type: "string",
};

export const dimensions = {
  label: "Dimension",
  type: "array",
  items: {
    type: "object",
    properties: {
      name: {
        type: "string",
        default: "",
        "minLength": 1
      },
      description: {
        type: "string",
        default: "",
      }
    }
  },
  default: [],
  widget: "list",
}

export const measures = {
  label: "Measures",
  type: "array",
  items: {
    type: "object",
    properties: {
      name: {
        type: "string",
        default: "",
        "minLength": 1
      },
      description: {
        type: "string",
        default: "",
      },
      type: {
        type: "string",
        "widget": "select",
        "enum": [
          "integer",
          "double",
          "boolean",
          "timestamp"
        ],
        "minLength": 1
      }
    },
    required: ["type"]
  },
  index: "uuid",
  default: [],
}















